module.exports = __webpack_public_path__ + "static/media/star_ehy-x_90.0d84bffb.png";